import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ItemService } from './item.service';



const ENTITY_STATES = [
];

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		RouterModule.forRoot(ENTITY_STATES, { useHash: true })
	],
	declarations: [
	],
	entryComponents: [
	],
	providers: [
		ItemService,
	],
	exports: [

	]
})
export class MainModule { }
